/* PetQuarters theme JS — no dependencies */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    function fmt(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      var v = (n / 100).toFixed(precision).split('.');
      return v[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (v[1] ? decimal + v[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/); var t = m ? m[1] : 'amount'; var val;
    switch (t) {
      case 'amount_no_decimals': val = fmt(cents, 0); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = fmt(cents, 2, "'", '.'); break;
      default: val = fmt(cents, 2);
    }
    return format.replace(m ? m[0] : '{{amount}}', val);
  }
  var toastEl, toastTimer;
  function toast(msg) {
    toastEl = toastEl || $('[data-toast]'); if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); return c; });
  }
  function addToCart(form, btn) {
    var label = btn && btn.querySelector('span');
    if (btn) btn.classList.add('is-loading');
    return fetch((window.theme && window.theme.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.d.description || res.d.message || 'Could not add this item'); return; }
        toast('Added to cart');
        return refreshCart();
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---------- drawers ---------- */
  function openPanel(el) { if (!el) return; el.classList.add('is-open'); document.body.style.overflow = 'hidden'; var f = el.querySelector('a,button,input'); f && setTimeout(function () { f.focus(); }, 60); }
  function closePanels() { $$('.drawer.is-open,.filters-panel.is-open').forEach(function (p) { p.classList.remove('is-open'); }); document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openPanel($('#' + (o.getAttribute('aria-controls') || 'nav-drawer'))); return; }
    var f = e.target.closest('[data-filters-open]');
    if (f) { e.preventDefault(); openPanel($('#filters-panel')); return; }
    if (e.target.closest('[data-drawer-close]')) { closePanels(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* ---------- quick add (product cards) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.classList.contains('js-quick-add') || form.classList.contains('js-product-form')) {
      e.preventDefault();
      addToCart(form, form.querySelector('button[type=submit]'));
    }
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]'); if (!b) return;
    var wrap = b.closest('.qty'); var input = $('input', wrap);
    var step = Number(b.getAttribute('data-qty-step')); var min = Number(input.min || 0);
    var next = Math.max(min, (Number(input.value) || 0) + step); input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-qty]'); if (!input) return;
    var line = input.getAttribute('data-cart-line-qty');
    input.closest('.line').style.opacity = '.5';
    fetch((window.theme.cartChangeUrl || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(input.value) })
    }).then(function () { window.location.reload(); });
  });

  /* ---------- product page ---------- */
  var pform = $('.js-product-form');
  var dataEl = $('[data-product-json]');
  if (pform && dataEl) {
    var product = JSON.parse(dataEl.textContent);
    var idInput = $('[name=id]', pform);
    var btn = $('[data-buy-btn]', pform);
    var msg = $('[data-pdp-msg]');
    var mainImg = $('[data-main-img]');
    function currentOptions() {
      return $$('.opt', pform).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) { return opts.every(function (o, i) { return o === v.options[i]; }); })[0];
    }
    function setPrice(v) {
      $$('[data-price]').forEach(function (p) {
        var now = $('[data-price-now]', p), was = $('[data-price-was]', p);
        now.textContent = v ? formatMoney(v.price) : now.textContent;
        if (v && v.compare_at_price > v.price) { was.textContent = formatMoney(v.compare_at_price); was.hidden = false; p.classList.add('price--sale'); }
        else { was.hidden = true; p.classList.remove('price--sale'); }
      });
    }
    function setImage(v) {
      if (!v || !v.featured_media || !mainImg) return;
      var th = $('[data-media-id="' + v.featured_media.id + '"]');
      if (th) th.click();
    }
    function update() {
      var v = findVariant(currentOptions());
      if (!v) { btn.disabled = true; $('span', btn).textContent = 'Unavailable'; if (msg) msg.textContent = 'This combination is not available.'; return; }
      if (msg) msg.textContent = '';
      idInput.value = v.id; setPrice(v);
      btn.disabled = !v.available;
      $$('[data-buy-label]').forEach(function (l) { l.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      $$('[data-sticky-btn]').forEach(function (b) { b.disabled = !v.available; });
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
      setImage(v);
    }
    pform.addEventListener('change', function (e) { if (e.target.closest('.opt')) update(); });
    $$('[data-sticky-btn]').forEach(function (b) { b.addEventListener('click', function () { btn.click(); }); });

    // gallery thumbs
    $$('.pdp-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = t.getAttribute('data-src'); mainImg.srcset = t.getAttribute('data-srcset') || ''; mainImg.alt = t.getAttribute('data-alt') || '';
        $$('.pdp-thumb').forEach(function (x) { x.setAttribute('aria-current', 'false'); }); t.setAttribute('aria-current', 'true');
      });
    });

    // sticky mobile buy bar
    var sticky = $('.sticky-buy');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(btn);
    }
  }

  /* ---------- newsletter / generic form feedback ---------- */
  $$('.js-clear-on-success').forEach(function (f) { if (f.querySelector('.form-msg--ok')) f.reset(); });

  /* keep count right when returning via back button */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
